import Modal from '@/lib/v2/components/Modal/Modal';
import Selectable, { ISelectable } from '@/lib/v2/components/Selectable';

interface IModalSelectable<T> {
  wordings: ISelectable<T>['wordings'];
  items: ISelectable<T>['items'];
  onClose: (value: boolean) => void;
  onAccept: ISelectable<T>['onAccept'];
  show: boolean;
  isAcceptDisabled?: boolean;
  limitSelection?: number;
  withCreateItem?: boolean;
  labelInputCreate?: string;
  onCreate?: (toCreate: string) => Promise<void>;
}

const ModalSelectable = <T,>(props: IModalSelectable<T>) => {
  return (
    <Modal noPadding withAuto externalClose={true} open={props.show} onClose={props.onClose}>
      <Selectable
        className="p-4"
        isAcceptDisabled={props.isAcceptDisabled}
        items={props.items}
        labelInputCreate={props.labelInputCreate}
        limitSelection={props.limitSelection || 20}
        withCreateItem={props.withCreateItem}
        wordings={props.wordings}
        onAccept={props.onAccept}
        onClose={props.onClose}
        onCreate={props.onCreate}
      />
    </Modal>
  );
};

export default ModalSelectable;
